import { Alert, Typography } from '@mui/material';

type MarkedAsDeletedAlertProps = {
  readonly geloeschtWeil: string | undefined;
};

export const MarkedAsDeletedAlert: React.FC<MarkedAsDeletedAlertProps> = ({
  geloeschtWeil,
}: MarkedAsDeletedAlertProps) => (
  <>
    {geloeschtWeil && (
      <Alert sx={{ mb: 2 }} severity="warning">
        <Typography variant="paragraph">
          {' '}
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Veranstaltung ist als "Zu Löschen" markiert und daher gesperrt. Grund: {geloeschtWeil}
        </Typography>
      </Alert>
    )}
  </>
);
